import { memo } from 'react';
import { CornerUpLeft, Pencil, X } from 'lucide-react';
import { IconButton } from '@cyphex/ui';
import type { Message } from '@cyphex/types';
import { previewText } from '../../lib/markdown/flatten';

interface ReplyBannerProps {
  message: Message;
  mode: 'reply' | 'edit';
  onCancel: () => void;
}

/** Context strip above the input when replying to or editing a message. */
export const ReplyBanner = memo(function ReplyBanner({ message, mode, onCancel }: ReplyBannerProps) {
  const Icon = mode === 'edit' ? Pencil : CornerUpLeft;
  const title =
    mode === 'edit' ? 'Editing message' : `Replying to ${message.sender?.displayName ?? 'message'}`;

  return (
    <div className="flex items-start gap-2 border-b border-border px-3 py-2">
      <Icon size={16} strokeWidth={2.25} className="mt-0.5 shrink-0 text-primary" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-primary">{title}</p>
        <p className="line-clamp-1 text-sm text-muted-foreground">
          {previewText(message.bodyText ?? '', 120)}
        </p>
      </div>
      <IconButton icon={X} label="Cancel" size="xs" variant="ghost" onClick={onCancel} />
    </div>
  );
});
